export interface ICustomerFuelPrice {
    id: number;
    customerId: number;
    productId: number;
    noomId: number;
    clientPrice: string;
    fixedPrice: boolean;
}

export interface IPublicFuelPrice {
    noomId: number;
    searchcode: string;
    name: string;
    price: string;
    idcPrice: string;
}

export interface IFuelPrice {
    type: string;
    colorCode: string;
    textColor: string;
    withoutVAT: string;
    withVAT: string;
    priceOnLocation: string;
    noomId: number;
    sortOrder: number;
    businessOnly?: boolean;
    fixedPrice?: boolean;
    unit: string;
    unitFixed: string;
}

const UNIT_CENTS_LITER = 's/L';
const UNIT_EUR_LITER = '€/L';
const UNIT_CENTS_KWH = 's/kWh';

export const FuelPricesMapping: IFuelPrice[] = [
    {
        type: 'B95',
        colorCode: '#46b67b',
        textColor: '#FFF',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 1133,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 1
    },
    {
        type: 'B98',
        colorCode: '#46b67b',
        textColor: '#FFF',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 1135,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 2
    },
    {
        type: 'D',
        colorCode: '#5f6971',
        textColor: '#FFF',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 1145,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 3
    },
    {
        type: 'reD',
        colorCode: '#3f9997',
        textColor: '#ffffff',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 16170,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 4
    },
    {
        type: 'LPG',
        colorCode: '#3086a2',
        textColor: '#ffffff',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 10654,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 5,
        businessOnly: true
    },    
    {
        type: 'D eri',
        colorCode: '#004B90',
        textColor: '#ffffff',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 1142,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 6
    },
    {
        type: 'AdBlue',
        colorCode: '#00A3FF',
        textColor: '#ffffff',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 3311,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 7
    },
    {
        type: 'Kl.pesu',
        colorCode: 'transparent',
        textColor: '#000000',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 3312,
        unit: UNIT_CENTS_LITER,
        unitFixed: UNIT_EUR_LITER,
        sortOrder: 8
    },
    {
        type: 'El. laadimine kuni 22kW',
        colorCode: '#0db6c0',
        textColor: '#FFFFFF',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 16538,
        unit: UNIT_CENTS_KWH,
        unitFixed: UNIT_CENTS_KWH,
        sortOrder: 9
    },    
    {
        type: 'El. laadimine kuni 50kW',
        colorCode: '#0db6c0',
        textColor: '#FFFFFF',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 16539,
        unit: UNIT_CENTS_KWH,
        unitFixed: UNIT_CENTS_KWH,
        sortOrder: 10
    },    
    {
        type: 'El. laadimine üle 50kW',
        colorCode: '#0db6c0',
        textColor: '#FFFFFF',
        withoutVAT: '',
        withVAT: '',
        priceOnLocation: '',
        noomId: 16540,
        unit: UNIT_CENTS_KWH,
        unitFixed: UNIT_CENTS_KWH,
        sortOrder: 11
    }

];
// @ts-ignore